import { createContext } from "react";

export const ChainsContext = createContext()